/**
 * Flagship deep dive for koreasnowwatch.com: Mona Yongpyong (모나용평).
 * Shape: FlagshipData in src/data/flagship.ts. Copy lives in ./guides/deepDive.ts
 * (sources in sites/kr/GUIDES_SOURCES.md); this file only assembles it.
 * Not routed on Korea any more (site.config has no routes.flagship): the deep dive,
 * travel guide and FAQ were folded into /resort/yongpyong/ through
 * ./pageSpotlights.ts, and the old /yongpyong/ URLs 301 there (./merged-pages.json).
 */
import type { FlagshipData } from '@/data/flagship';
import {
  FLAGSHIP_RESORT_SLUG,
  YONGPYONG_DEEP_DIVE,
  YONGPYONG_FAQ_COPY,
  YONGPYONG_GUIDE_COPY,
  YONGPYONG_PAGE_COPY,
} from './guides/deepDive';

export const FLAGSHIP: FlagshipData = {
  resortSlug: FLAGSHIP_RESORT_SLUG,
  name: { ko: '용평', en: 'Yongpyong', ja: '龍平（ヨンピョン）', zh: '龙平' },
  resortName: { ko: '모나용평', en: 'Mona Yongpyong', ja: '龍平リゾート', zh: '龙平度假村' },
  badge: { ko: '강원 평창 · 대관령', en: 'Gangwon · Pyeongchang', ja: '江原道 平昌', zh: '江原道 · 平昌' },
  address: 'Daegwallyeong-myeon, Pyeongchang-gun, Gangwon, South Korea',
  region: 'Gangwon',
  latitude: 37.6458,
  longitude: 128.6805,
  faqRelated: {
    resortGuide: { ko: '모나용평 가이드', en: 'Yongpyong resort guide', ja: '龍平リゾート ガイド', zh: '龙平度假村指南' },
    travelGuide: { ko: '용평 여행 가이드', en: 'Yongpyong travel guide', ja: '龍平 旅行ガイド', zh: '龙平旅行指南' },
    countryFaq: { ko: '한국 스키 전체 FAQ', en: 'Korea skiing FAQ', ja: '韓国スキー全般のFAQ', zh: '韩国滑雪常见问题' },
  },
  main: YONGPYONG_PAGE_COPY,
  deepDive: YONGPYONG_DEEP_DIVE,
  guide: YONGPYONG_GUIDE_COPY,
  faq: YONGPYONG_FAQ_COPY,
};
